import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { AdditionalInfo } from 'src/app/model/additional-info';

@Component({
  selector: 'gymfinder-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false,
})
export class AdditionalInfoComponent {
  @Input()
  additionalInfo: AdditionalInfo;

  @Input()
  editMode: boolean;

  @Output()
  additionalInfoChange = new EventEmitter<AdditionalInfo>();
}
